import { ToWords } from 'to-words'
import MOMENT from 'moment'
import NUMERAL from 'numeral'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  data () {
    return {
      currencyMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        // requireDecimal: true,
        decimalSymbol: '.',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowNegative: false,
        integerLimit: 10,
        decimalLimit: 2
      })
    }
  },

  methods: {
    weekFormatter (value) {
      if (value) {
        return MOMENT(value).format('dddd')
      }

      return ''
    },

    timeFormatter (value) {
      if (value) {
        return MOMENT(value).format('LT')
      }
      return ''
    },

    dateFormatter (value) {
      if (value) {
        return MOMENT(value).format('Y-MM-DD')
      }
      return ''
    },

    dateLongFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMMM DD, YYYY')
      }
      return ''
    },

    dateShortFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMM DD, YYYY')
      }
      return ''
    },

    dateTimeFormatter (value) {
      if (value) {
        return MOMENT(value).format('Y-MM-DD HH:mm:ss')
      }
      return ''
    },

    dateTimeShortFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMM DD, YYYY @ LT')
      }
      return ''
    },

    dateTimeShortMilitaryFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMM DD, YYYY @ HH:mm')
      }
      return ''
    },

    dateTimeLongFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMMM DD, YYYY @ LT')
      }
      return ''
    },

    dateTimeLocalFormatter (value) {
      if (value) {
        return MOMENT(value).format('YYYY-MM-DDTHH:mm')
      }
      return ''
    },

    dateMonthFormatter (value) {
      if (value) {
        return MOMENT(value).format('MM-DD')
      }
      return ''
    },

    dateMonthShortFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMM DD')
      }
      return ''
    },

    monthFormatter (value) {
      if (value) {
        return MOMENT(value).format('YYYY-MM')
      }
      return ''
    },

    monthShortFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMM YYYY')
      }
      return ''
    },

    monthLongFormatter (value) {
      if (value) {
        return MOMENT(value).format('MMMM YYYY')
      }
      return ''
    },

    numberDefaultFormatter (value) {
      if (value || value <= 0) {
        return NUMERAL(value).format('0,0.00')
      }
      return ''
    },

    numberFormatter (value, format = '0,0.00') {
      if (value || value <= 0) {
        return NUMERAL(value).format(format)
      }
      return ''
    },

    numberToWords (value) {
      const number = new ToWords({
        localeCode: 'en-US',
        converterOptions: {
          currency: true,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
          doNotAddOnly: false,
          currencyOptions: { // can be used to override defaults for the selected locale
            name: 'Peso',
            plural: 'Pesos',
            symbol: '',
            fractionalUnit: {
              name: 'Cent',
              plural: 'Cents',
              symbol: ''
            }
          }
        }
      })
      return number.convert(value)
    },

    yesOrNo (value) {
      if (value !== null && value !== '') {
        return Number(value) === 1 ? 'Yes' : 'No'
      }

      return ''
    },

    objectToUrl (payload, includeNoValues = true) {
      const payloadKeys = Object.keys(payload)

      if (payloadKeys.length <= 0) {
        return ''
      }

      return payloadKeys.map(
        payloadKey => {
          if (typeof payload[payloadKey] === 'undefined' || payload[payloadKey] === 'null' || payload[payloadKey] === null) {
            return includeNoValues ? `${payloadKey}=` : ''
          }

          if (Array.isArray(payload[payloadKey]) > 0) {
            return this.arrayToUrlLists(
              Array.from(payload[payloadKey]),
              payloadKey
            )
          }

          return `${payloadKey}=${payload[payloadKey]}`
        }
      ).filter(value => value).join('&').toString()
    },

    arrayToUrlLists (values, payloadKey = 'lists') {
      if (Array.isArray(values) <= 0) {
        return ''
      }

      return values.filter(value => value).map(
        value => `${payloadKey}[]=${value}`
      ).join('&').toString()
    },

    getFullName (_value, _key, userData) {
      const user = userData?.user ? userData.user : userData
      if (user?.first_name && user?.last_name) {
        if (user?.middle_name) {
          const middleName = String(user?.middle_name || '')
          if (middleName.length > 0) {
            return `${user.first_name} ${middleName.charAt(0)}. ${user.last_name}`
          }
        }

        return `${user.first_name} ${user.last_name}`
      }

      return ''
    },

    getFullAddress (_value, _key, userData) {
      const province = userData?.province ? userData.province : userData
      const municipality = userData?.municipality ? userData.municipality : userData
      const barangay = userData?.barangay ? userData.barangay : userData

      const provinceName = province?.province_name ? province.province_name : ''
      const municipalityName = municipality?.municipality_name ? municipality.municipality_name : ''
      const barangayName = barangay?.barangay_name ? barangay.barangay_name : ''

      if (provinceName.length > 0 && municipalityName.length > 0 && barangayName.length > 0) {
        return `${barangayName}, ${municipalityName}, ${provinceName}`
      }

      return ''
    }
  }
}
